
  Vue.component('seeker-lists-new-list-button', {
    props: {
      buttonText: {
        type: String,
        default: 'Crea nuova lista'
      }
    },
    data() {
      return {
        text: this.buttonText
      }
    },
    pinia: Vue.pinia,
    template: '#seeker-lists-new-list-button',
    watch: {},
    computed: {},
    methods: {
      // modalsStore actions
      ...Pinia.mapActions(useModalsStore, ['showNewSeekerListModal'])
    },
    mounted() {}
  })
